<template>
  <div style="text-align:center">
    <Row>
      <Col span="8">
        <Button
          icon="md-cloud-download"
          long
          type="primary"
          @click="exportMeterInfoTemplate"
        >导出设备注册模板</Button>
      </Col>
    </Row>
    <Row style="margin-top:10px">
      <Col span="8">
        <Button
          type="primary"
          icon="md-cloud-upload"
          long
          onclick="$('#upload_file_meter').click();"
        >按设备模板导入并注册</Button>
      </Col>
      <Col span="8">
        <Upload
          ref="upload"
          name="upfile"
          action="/api/importMeterInfoTemplate"
          :on-success="handleImportMeterInfoTemplate"
          :format="['xlsx','xls']"
          :show-upload-list="false"
          :on-error="handleError"
        >
          <input id="upload_file_meter" style="display: none;" />
        </Upload>
      </Col>
    </Row>
  </div>
  <!-- <div style="width:100%; position:relative; margin-top:15px;"> -->
  <!-- <Form ref="formValidate" :label-width="120"> -->
  <!-- <FormItem label="批次日期">
        <DatePicker type="date" v-model="formValidate.date" format="yyMMdd" placeholder="请选择批次日期"></DatePicker>
  </FormItem>-->
  <!-- <FormItem label="通讯方式">
        <Select v-model="formValidate.commType">
          <Option value="nb">NB</Option>
          <Option value="wifi">WIFI</Option>
          <Option value="ctnnb">NB(电信)</Option>
        </Select>
  </FormItem>-->
  <!-- <FormItem label="设备序号" v-if="formValidate.commType == 'ctnnb'">
        <Input v-model="formValidate.meterNo" placeholder="请输入设备序号"></Input>
      </FormItem>
      <FormItem label="设备串号" v-if="formValidate.commType == 'ctnnb'">
        <Input v-model="formValidate.meterSerialNumber" placeholder="请输入设备串号"></Input>
      </FormItem>

      <FormItem label="起始序号(≥)" v-if="formValidate.commType != 'ctnnb'">
        <Input v-model="formValidate.meterNoStart" placeholder="请输入起始序号"></Input>
      </FormItem>
      <FormItem label="结束序号(≤)" v-if="formValidate.commType != 'ctnnb'">
        <Input v-model="formValidate.meterNoEnd" placeholder="请输入结束序号"></Input>
  </FormItem>-->
  <!-- </Form> -->

  <!-- <div style="left:45%; position:relative;">
      <Button style="margin-right:10px" @click="commit" type="primary">提交注册</Button>
      <Button @click="showResult = true" type="primary">查看结果</Button>
    </div>

    <Drawer width="340" title="设备注册结果" :closable="false" v-model="showResult">
      <p v-for="(value, key) in array" :key="key" :value="value">
        <span>
          {{value.id + " "}}
          <span v-if="value.state == '等待注册'" style="color:blue">{{value.state}}</span>
          <span v-if="value.state == '注册成功'" style="color:green">{{value.state}}</span>
          <span
            v-if="value.state != '注册成功' && value.state != '等待注册'"
            style="color:red"
          >{{value.state}}</span>
        </span>
        <Icon
          color="blue"
          type="ios-loading"
          v-if="value.state == '等待注册'"
          size="18"
          class="demo-spin-icon-load"
          style="margin-left:10px"
        ></Icon>
        <Icon
          color="green"
          type="ios-checkmark-circle-outline"
          v-if="value.state == '注册成功'"
          size="18"
          style="margin-left:10px"
        ></Icon>
        <Icon
          color="red"
          type="ios-close-circle-outline"
          v-if="value.state != '注册成功' && value.state != '等待注册'"
          size="18"
          style="margin-left:10px"
        ></Icon>
      </p>
    </Drawer>
  </div>-->
</template>
<script>
export default {
  name: "meter_regist",
  mounted() {
    this.formValidate.date = global.dateFtt("yyMMdd", new Date());
  },
  methods: {
    handleError(error, file, fileList) {
      console.log(error);
      console.log(file);
      console.log(fileList);
      this.$Notice.error({
        title: "导入失败",
        desc: error,
        duration: 0
      });
    },
    handleImportMeterInfoTemplate(response, file, fileList) {
      console.log(response);
      console.log(file);
      console.log(fileList);
      this.handelResponse(response);
    },
    handelResponse(response) {
      if (response.errorCode != 0) {
        this.$Notice.error({
          title: "导入失败",
          desc: response.errorInfo,
          duration: 0
        });
      } else {
        let result = response.body.repeatArray;
        let insert = response.body.insertArray;
        let count = "\n共计导入" + insert.length + "条数据。";
        let indexs = "";
        if (result.length > 0) {
          result.map(item => {
            indexs =
              indexs == "" ? item.index + 2 : indexs + "," + (item.index + 2);
          });
        }
        let msg =
          indexs == ""
            ? ""
            : "\n第" + indexs + "行数据与数据库中数据重复,不予导入。";
        this.$Notice.success({
          title: "成功",
          desc: "导入成功！" + msg + count,
          duration: 0
        });
      }
    },
    exportMeterInfoTemplate() {
      window.location.href = this.meterInfoUrl;
    },
    setTime(e) {
      this.formValidate.date = e;
    },
    regist(meterArray, commType) {
      var defer = $.Deferred();
      Object.keys(meterArray).forEach(function(value, i) {
        var meterId = meterArray[value].id;
        var imei = meterArray[value].imei;

        var that = this;
        $.ajax({
          url:
            "/api/registerMeter?meterId=" +
            meterId +
            "&commType=" +
            commType +
            "&imei=" +
            imei,
          contentType: "application/json",
          type: "get",
          dataType: "json",
          success: function(data) {
            console.log(data);
            if (data.errorCode != 0) {
              meterArray[value].state = data.errorInfo;
              return;
            } else {
              let temp = JSON.parse(data.body);
              if (temp.errorCode == 0) {
                meterArray[value].state = "注册成功";
              } else {
                meterArray[value].state = temp.errorInfo;
              }
            }
          },
          error: function(textStatus) {
            that.$Notice.error({
              title: "异常",
              desc: "接口调用异常"
            });
          },
          complete: function(XMLHttpRequest, textStatus) {}
        });
      });
      return defer.promise();
    },

    commit() {
      let meterIdArray = {};
      if (this.formValidate.commType == "ctnnb") {
        let batch = global.dateFtt("yyMMdd", this.formValidate.date);
        let i = this.formValidate.meterNo;

        let sup = "";

        while ((batch + sup + i).length < 14) {
          sup = sup + "0";
        }
        let tempObject = {};

        tempObject["id"] = batch + sup + i;
        tempObject["imei"] = this.formValidate.meterSerialNumber;
        tempObject["state"] = "等待注册";
        meterIdArray[batch + sup + i] = tempObject;

        this.array = meterIdArray;
        this.showResult = true;

        this.regist(this.array, this.formValidate.commType);
      } else {
        console.log(!isNaN(parseInt(this.formValidate.meterNoStart)));
        console.log(this.formValidate.meterNoStart > 0);
        console.log(!isNaN(parseInt(this.formValidate.meterNoEnd)));
        console.log(this.formValidate.meterNoEnd.length < 9);

        if (
          !isNaN(parseInt(this.formValidate.meterNoStart)) &&
          this.formValidate.meterNoStart > 0 &&
          !isNaN(parseInt(this.formValidate.meterNoEnd)) &&
          this.formValidate.meterNoEnd <= 99999999
        ) {
          let batch = global.dateFtt("yyMMdd", this.formValidate.date);

          for (
            let i = parseInt(this.formValidate.meterNoStart);
            i <= parseInt(this.formValidate.meterNoEnd);
            i++
          ) {
            let tempObject = {};
            let sup = "";

            while ((batch + sup + i).length < 14) {
              sup = sup + "0";
            }

            tempObject["id"] = batch + sup + i;
            tempObject["state"] = "等待注册";
            meterIdArray[batch + sup + i] = tempObject;
          }

          this.array = meterIdArray;
          this.showResult = true;

          this.regist(this.array, this.formValidate.commType);
        } else {
          this.$Modal.info({
            title: "提示",
            content: "请填写正确参数"
          });
        }
      }
    }
  },
  data() {
    return {
      meterInfoUrl: "/api/downloadMeterInfoTemplate",
      showResult: false,
      array: {},
      formValidate: {
        date: "",
        meterNoStart: 1,
        meterNoEnd: 100,
        commType: "wifi"
      }
    };
  }
};
</script>
<style>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
</style>